import Queue from 'nq';

class GetCurrentUserUseCase {
    execute(options) {
        return new Queue.User().getCurrentUser(options);
    }
}

export default GetCurrentUserUseCase;
